import './action-list.css';
export default {
  "actionList": "pf-v6-c-action-list",
  "actionListGroup": "pf-v6-c-action-list__group",
  "modifiers": {
    "icons": "pf-m-icons"
  }
};